export class MESSAGECONSTANTS {
    public static ALERT_MESSAGES = {
        'PLEASE_CONFIRM':'Please confirm',
        'YES_USE_IT':'Yes, use it',
        'YES_ARCHIVE_IT':'Yes, archive it',
        'YES_REMOVE_OTHERS':'Yes, remove others',
        'YES_REMOVE_IT':'Yes, remove it',
        'YES_RESTORE_IT':'Yes, restore it',
        'CAMPAIGN_EXPIRED':'Campaign expired',
        'CAMPAIGN_EXPIRED_TITLE':'The mission is within an overdue campaign. If you want to select a new assignment date, please first contact your Admin in order to expand campaign duration.',
        'NEED_MORE_CHECKPOINTS':'Need more checkpoint/s',
        'YES_CHANGE_IT':'Yes, change it',
        'YES_REMOVE_THEM':'Yes, remove them',
        'YES_I_WILL_CHANGE_IT':'Yes, I will change it',
        'NO_CANCEL':'No, cancel',
        'YES_DELETE_IT':'Yes, delete it',
        'THANK_YOU':'Thank you',
        'YES_USE_EXISTING_ZONE':'Yes, use exising zone',
        'NO_CHANGE_CHECKPOINTS_ONLY':'No, change checkpoint only',
        'CHANGE_THE_MISSION_DATE':'Change the mission date',
        'IT_SHOULD_BE_MORE_THAN_TODAY':'It should be more than today',
        'GOOGLE_GEOCODING_ERROR':'Google geocoding error',
        'PLEASE_FILL_ALL_DETAILS_ENG' : 'Please fill up all fields',
        'PASSWORD_SHOULD_MATCH': 'Passwords should match.',
        'PASSWORD_CHANGED_SUCCESSFULLY': 'Password changed successfully',
        'INVALID_CREDENTIALS' :'Invalid Credentials!',
        'PLEASE_TRY_AGAIN' :'Please try again.',
        'PLEASE_READ_CAREFULLY' :'Please read carefully.',
        'BOTH_FIELDS_NEEDS_TO_BE__MANDATORY': 'Both fields needs to be filled mandatorily. Both passwords should match.',
        'PASSWORD_MINIMUM_8_CHAR_REQUIRED' :'In password minimum 8 characters required with 1 uppercase, 1 lowercase, 1 number and 1 special charachter.',
        'SOMETHING_WENT_WRONG':'Something went wrong',
        'YOUR_NEW_PASSWPRD_HAS_BEEN_SET':'Your new password has been set.',
        'PLEASE_LOGIN':'Please login.',
        'DO_YOU_WANT_TO_REASSIGN_MISSION' :'Do you want to reassign this mission?',
        'MORE_CHECKPOINTS_NEEDED' :'More checkpoints needed',
        'PLEASE_ADD_CHECKPOINTS' :'Please add checkpoints',
        'SESSION_EXPIRED' :'Session Expired!',
        'PLEASE_LOGIN_AGAIN':'Please login again.',
        'PLEASE_CONTACT_ADMIN_FOR_MORE_CAMPAIGNS':'Please contact admin for more campaigns',
        'FILE_SIZE_SHOULD_NOT_BE_MORE_THAN_20MB':'File size should not be more than 20MB',
        'FILE_SHOULD_BE_JPG_JPEG_PNG_EXTENTION':'File Type Should be .jpg, .jpeg, .png extension',
        'NO_FIELDS_AGENT_FREE_MISSION_START_DATE':'No field agents free on the mission start date',
        'PLEASE_ASK_ADMIN_TO_ADD_FIELDS_AGENT':'Please ask admin to add field agents or change the mission date',
        'DAILY_LIMIT_FOR_TODAY_REACHED_FOR_SEARCHING_LOCATION':'Daily limit for today reached for searching a location',
        'FEATURE_NEEDS_TO_BE_KEPT_COMMON_AMONGST_CHECKPOINTS':'As this feature needs to be kept common amongst the checkpoints',
        'PLEASE_NOTE':'Please note:',
        'YOU_CHANGE_THIS_THE_DATA_WILL_BE_DELETED':'In case you change this the data will be deleted',
        'TODAYS_DAILY_LIMIT_REACHED_FOR_SEARCHING_A_LOCATION':'Todays daily limit reached for searching a location',
        'PLEASE_SEARCH_LOCATION_AT_CHECKPOINT_IN_MAP_AS_WELL':'Please search the location of the checkpoint in the map as well',
        'MISSION_UDPATED_SUCCESSFULLY':'Mission updated successfully',
        'ALL_FIELDS_MANDATORY_IN_MISSION_FORM':'All fields mandatory in mission form',
        'DO_YOU_WANT_TO_CONTINUE':'Do you want to continue',
        'PLEASE_CHANGE_ADPTID_OF_CHECKPOINT':'Please change the adptId of a checkpoint',
        'NO_I_WILL_CHANGE_IT':'No, I will change it',
        'YES_NOT_ABLE_TO_USE_SAME_CHECKPOINT':'You will not be able to use the same checkpoint',
        'STREETS_NOT_AVAILABLE':'Streets not available',
        'ADPTID_NOT_AVAILABLE':'Adptid not available',
        'SAME_SHIFT_CANNOT_BE_ASSIGNED':'Same shift cannot be assigned',
        'PLEASE_SELECT_CAMPAIGN':'Please select campaign',
        'PLEASE_SELECT_ANOTHER_SHIFT':'Please select another shift',
        'CANNOT_ASSIGN_SHIFT_TIMING_WITH_SAME_ITERATION_COUNT':'Cannot assign shift timing with same iteration count',
        'DATE_MISSION_FIELDS_MANDATORY':'Date and Mission name fields are mandatory',
        'ALL_DATES_ARE_MANDATORY':'All dates are mandatory',
        'ADRN_NOT_AVAILABLE':'Adrn not available',
        'PLEASE_SELECT_OTHER_OPTION':'Please select other option',
        'PLEASE_CHECK_IF_LOCATION_SEARCHED_fROM_MAP_AS_WELL_as_IMAGE_IS_ADDED':'Please check if location searched from map as well as image is added',
        'POSTAL_CODE_NOT_AVAILABLE':'Postal code not available',
        'CREATING_CHECKPOINTS_IN_THEM':'for creating checkpoints in them',
        'SELECT_MISSION_NOT_BE_ABLE':'that if you select this mission type you will not be able ',
        'CHECKPOINTS_MORE_THAN_THREE_WILL_BE_REMOVED':'to create checkpoints more than 3 and checkpoints more than 3 will be removed',
        'FIELD_AGENT_USED_IN_ASSIGNMENT':'This field agent is already used in an assignment',
        'PLEASE_SELECT_ANOTHER_FIELD_AGENT':'Please select another field agent',
        'PLEASE_SELECT_QUARTIER_FOR_MISSION':'Please select quartier for this mission',
        'MISSION_CREATED_SUCCESSFULLY':'Mission created successfully',
        'QUARTIER_ASSIGNED_SUCCESSFULLY':'Quartier assigned successfully',
        'ASSIGNMENT_COMPLETED_SUCCESSFULLY':'Assignment completed successfully',
        'SOMETHING_WENT_WRONG_OR_MORE_ASSIGNMENTS_NOT_SUCCESSFULLY_CREATED':'something went wrong one or more assignments not successfully created',
        'DAILY_LIMIT_REACHED_FOR_SEARCHING_LOCATION':'Daily limit for today reached for searching a location',
        'PLEASE_ENTER_VALID_ADPTID':'Please enter a valid ADPTID',
        'PLEASE_ADD_MORE_CHECKPOINTS':'Please add more checkpoints',
        'PLEASE_CHANGE_AN_ADPTID_TO_CONTINUE':'Please change an adptId to continue',
        'PLEASE_CHECK_THESE_CONDITIONS_B4_SUBMITTING':'Please check these conditions before submiting',
        'ARE_U_SURE_U_WANT_TO_REMOVE_THIS_CHECKPOINT':'Are you sure you want to remove this checkpoint',
        'YOU_CANNOT_RETRIEVE_THIS_CHECKPOINT_ONCE_DELETED':'You cannot retrieve this checkpoint once deleted',
        'CHANGING_MISSION_DATE_WILL_REMOVE_ALL_ASSIGNMENTS':'Changing the mission date will remove all assignments',
        'ARE_YOU_SURE_TO_CHANGE_MISSION_DATE':'Are you sure to change mission date',
        'DO_YOU_WANT_TO_CHANGE_IT':'Do you want to change it',
        'ONCE_REMOVED_YOU_WILL_NOT_BE_ABLE_TO_RECOVER_THEM_AGAIN':'Once removed you will not be able to recover them again',
        'CHECKPOINTS_DELETED_SUCCESSFULLY':'Checkpoints deleted successfully',
        'ADPTID_REQUIRED_PLEASE_CHECK_CHECKPOINT_NAME_IS_UNIQUE':'AdptId is required. And please check if the checkpoint name is unique as well as the adptid is unique',
        'NO_REPORTS_GENERATED': 'No reports generated',
        'APPROVED_MPD_SUCCESSFULLY':'Mission approved successfully',
        'DATA_NOT_YET_SYNCED_FOR_THIS_MISSION':'Data is not yet synced for this mission',
        'ZONE_WITH_THE_SAME_NAME_ALREADY_PRESENT':'Zone with the same name already present',
        'DO_YOU_WANT_TO_USE_THE_EXISTING_ZONE':'Do you want to use the exisiting zone',
        'CAMPAIGN_ABOUT_TO_EXPIRE':'Campaign about to expire',
        'MISSION_DETAILS_UPDATED_SUCCESSFULLY':"Mission details updated successfully",
        'SOMETHING_WENT_WRONG_WHILE_UPDATING_MISSION':"Something went wrong while updating mission",
        'PLEASE_CONTACT_ADMIN':'Please contact Admin',
        'YES_REASSIGN':'Yes, reassign!',
        'ACCOUNT_NOT_ACTIVE':'Account not active',
        'PLEASE_CONTACT_ADMIN_TO_ACTIVTE_UR_ACCOUNT':'Please contact administrator to activate your account.',
        'INCORRECT_USERNAME_OR_PASSWORD':'Incorrect username or password.',
        'INVALID_EMAIL':'Invalid email',
        'PLEASE_ENTER_A_VALID_EMAIL':'Please enter a valid email.',
        'VERIFICATION_CODE_SENT_TO_REGISTERED_EMAIL':'Verification Code sent to registered email address',
        'ALL_FIELDS_ARE_MANDATORY':'All fields are mandatory',
        'ACCOUNT_UPDATED_SUCCESSFULLY':'Account updated successfully',
        'CAMPAIGN_ASSIGNED_TO_THIS_USER':'Campaign assigned to this user',
        'PLEASE_REASSING_CAMPAIGN_THEN_DEACTIVATE_THE_USER':'Please re-assign the campaign and then deactivate the user',
        'ARE_YOU_SURE_WANT_TO_DEACTIVATE_USER':'Are you sure you want to de-activate user',
        'MISSION_ASSIGNED_TO_THIS_USER':'Mission assigned to this user',
        'PLEASE_REASIGN_THE_MISSION_THEN_DEACTIVATE_THIS_USER':'Please re-assign the misson and then deactivate this user',
        'YES_DEACTIVATE_USER':'Yes, de-activate user',
        'ARE_YOU_SURE_U_WANT_TO_ACTIVATE_USER':'Are you sure you want to activate user',
        'YES_ACTIVATE_USER':'Yes, activate user',
        'PLEASE_FILL_UP_ALL_FIELDS':'Please fill up all the fields',
        'VERIFIED_AND_EMAIL_SENT_SUCCESSFULLY':'verified and email sent successfully',
        'HAS_NOT_BEEN_ACTIVATED':'has not been activated. Email not sent',
        'ALREADY_ACTIVATED_PLEASE_ASK_TO_LOGIN':'is/are already activated. Please ask to login',
        'CANNOT_BE_VERIFIED_NOT_PRESENT_IN_SES_STACK':'can\'t be verified. Not present in the SES Stack',
        'HAVE_ALREADY_BEEN_ACTIVATED_PASSWORD_NEEDS_TO_BE_RESET':'have already been activated but password needs to be reset.',
        'HAVE_ALREADY_BEEN_VERIFIED_BUT_ARE_NOT_ACTIVATED':'have already been verified but are not activated.',
        'PLEASE_CONTACT_ADMIN_FOR_THE_ASSISTANCE':'Please contact the administrator for assistance',
        'USER_UPDATED_SUCCESSFULLY':'User updated successfully',
        'PLEASE_ACTIVATE_THIS_SUPERVISOR_TO_ACCESS_HIS_TEAM':'Please activate this supervisor to access his team',
        'ACTIVATE_THIS_SUPERVISOR_TO_ACCESS_THE_TEAM':'Activate this supervisor to access the team',
        'PLEASE_SELECT_VALID_FIELD_AGENT':'Please select a valid field agent',
        'PLEASE_SELECT_SUPERVISOR':'Please select a Supervisor',
        'TEAM_UPDATED_SUCCESSFULLY':'Team updated successfully',
        'ALREADY_INCLUDED_IN_MODULES':'Already included in modules.',
        'PLEASE_SELECT_MODULES_FOR_THE_ROLE':'Please select modules for the role',
        'IF_YOU_WANT_TO_DELETE_ROLE_PLEASE_ASK_ADMIN':'Each role requires at least one module assigned to it. If you want to delete the role please ask the admin.',
        'ROLE_UPDATED_SUCCESSFULLY':'Role updated successfully',
        'BOTH_FIELDS_MANDATORY':'Both fields Mandatory',
        'TEAM_CREATED_SUCCESSFULLY':'Team Created Successfully',
        'PLEASE_SELECT_SUPERVISOR_AND_FIELD_AGENTS':'Please select supervisor and field agents to create a team',
        'PLEASE_SELECT_VALID_SUPERVISOR':'Please select a valid supervisor',
        'PLEASE_ADD_MODULES_TO_THE_ROLE':'Please add modules to the role',
        'NO_MODULES_ADDED_FOR_THIS_ROLE':'No modules added for this role.',
        'PLEASE_ADD_ROLE_NAME':'Please add Role name',
        'ROLE_NAME_REQUIRED':'Role name required.',
        'ROLE_CREATED_SUCCESSFULLY':'Role created Successfully',
        'ARE_YOU_SURE_U_WANT_TO_RESTORE_THIS_CAMPAIGN':'Are you sure you want to restore this campaign',
        'ALL_THE_DATA_IN_IT_WILL_BE_RESTORED':'All the data in it will be restored',
        'THE_USER_SHOULD_BE_A_SUPERVISOR':'The user should be a supervisor',
        'PLEASE_SELECT_VALID_USER':'Please select valid user',
        'ARE_U_SURE_U_WANT_TO_LOGOUT':'Are you sure you want to log out',
        'YES_LOGOUT':'Yes, log out',
        'ADDED_SUCCESSFULLY':'added successfully',
        'ACTIVATION_EMAIL_SENT':'Activation email sent',
        'HAS_ALREADY_BEEN_REGISTERED_AND_IS_ACTIVE':'has already been registered and is active',
        'HAS_ALREADY_BEEN_REGISTERED_AND_IS_NOT_ACTIVE':'has already been registered and is not active',
        'PLEASE_ASK_ADMIN_FOR_REACTIVATION':'Please ask admin for re-activation',
        'ALREADY_REGISTERED':'already registered',
        'EMAIL_ALREADY_BEEN_SENT_TO':'An email has already been sent to',
        'TO_CLICK_ON_THE_ACTIVATION_LINK':'to click on the activation link',
        'THE_EMAIL_WAS_NOT_SENT_TO':'The email was not sent to',
        'VERIFICATION_LINK_SENT_VIA_EMAIL':'Verification link sent via Email',
        'PLEASE_ASK_TO_CLICK_THE_LINK_TO_ACTIVATE_THE_ACCOUNT':'Please ask to click the link to activate the account',
        'FILL_UP_ALL_FIELDS_AS_MENTIONED_BELOW':'Fill up all fields as mentioned below',
        'PLEASE_FILL_UP_ALL_FIELDS_WITH_VALID_DATE':'Please fill up all the fields with valid data, i.e.,',
        'EMAIL_INPUT_SHOULD_BE_AN_EMAIL_AND_4_CONTACT_IT_SHOULD_BE_NUMBER':'For email the input should be an email & for contact, it should be number only',
        'ARE_U_SURE_U_WANT_TO_ARCHIVE_THIS_CAMPAIGN':'Are you sure you want to archive this campaign',
        'ALL_DATA_WILL_BE_ARCHIVED':'All the data in it will be archived',
        'NO_AGENT_FOUND': 'No Agents Available',
        'PLEASE_SELECT_OTHER_DATE_RANAGE': 'Please select other date range',
        'PLEASE_ENTER_VALID_LOCATION': 'Please enter valid location',
        'INVALID_LOCATION': 'Invalid location'
    };
}



// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/app/constants/constant-messages.ts